// src/views/NotFound.js
import React from 'react';
import ErrorImage from "../img/error-img.jpg";

const StyledImage ={
  width: '100%',
  maxWidth: '450px !important',
  marginBottom: '30px'
}

const NotFound = () => (
  <div className='error-page text-center' style={{padding: '50px 0px'}}>
    <div className='container'>
        <img style={StyledImage} src={ErrorImage} alt="" />
        <h2>Sorry, the page you are looking for does not exist.</h2>
    </div>
  </div>
);

export default NotFound;



// WEBPACK FOOTER //
// ./src/app/views/NotFound.js